import React, {useEffect} from "react";
import Footer from "../../components/footer/Footer";
import TrustedCompanies from "../../components/trustedCompanies/TrustedCompanies";

import ServiceFeatures from "./components/features/ServiceFeatures";
import ServicesHeroSection from "./components/hero/ServicesHeroSection";

import "./Services.scss";

const Services = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
  return (
    <div className="Services">
      <ServicesHeroSection />
      <ServiceFeatures />
      <TrustedCompanies />
      <Footer />
    </div>
  );
};

export default Services;
